import './MainNavigation.css';
import logo from '../assets/logo_up.png';
function Header() {
return <div className="main-nav">
<div className='logo'><img src={logo}></img></div>
<ul>
<li><a href="#">Home</a></li>
<li><a href="#">About Us</a></li>
<li><a href="#">Contact us</a></li>
</ul>
<ul className='header-right'>
  <li><a href="#">Login</a></li>
</ul>
</div>
}

export default Header;